export default __webpack_public_path__ + "static/media/pc.94b7aa15.svg";